import { ReactElement, ReactNode } from 'react';

import { CircularIcon } from '../CircularIcon/CircularIcon';
import { Row } from '../Row/Row';
import { TipContainer, TipText } from './style';

export interface TipProps {
	onlyIcon?: boolean;
	icon?: ReactElement;
	children?: ReactNode;
	append?: ReactNode;
}

export function Tip({ onlyIcon = false, icon, children, append }: TipProps) {
	return (
		<TipContainer>
			<Row $gap={10} $vcenter={true}>
				<CircularIcon size={48} icon={icon} />
				{!onlyIcon && <TipText>{children}</TipText>}
				{append && append}
			</Row>
		</TipContainer>
	);
}
